import { ActorQueryResultSerializeTree } from './ActorQueryResultSerializeTree';

const { bindingsStreamToGraphQl } = ActorQueryResultSerializeTree;
export { bindingsStreamToGraphQl };

export * from './ActorQueryResultSerializeTree';
